import { useCallback, useEffect, useState } from 'react'

const SHARED_MODAL_UI_STATE_KEY = 'sharedModalUiState'
const SHARED_MODAL_UI_EVENT = 'shared-modal-ui-state-change'

const readSharedState = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(SHARED_MODAL_UI_STATE_KEY) || '{}')
    return {
      showFilter: parsed.showFilter === undefined ? false : Boolean(parsed.showFilter),
      showSearch: parsed.showSearch === undefined ? false : Boolean(parsed.showSearch)
    }
  } catch {
    return { showFilter: false, showSearch: false }
  }
}

const writeSharedState = (nextState) => {
  localStorage.setItem(SHARED_MODAL_UI_STATE_KEY, JSON.stringify(nextState))
  window.dispatchEvent(new Event(SHARED_MODAL_UI_EVENT))
}

const useSharedModalUiState = () => {
  const [sharedState, setSharedState] = useState(() => readSharedState())

  useEffect(() => {
    const syncState = () => {
      setSharedState(readSharedState())
    }

    const onStorage = (event) => {
      if (event.key && event.key !== SHARED_MODAL_UI_STATE_KEY) return
      syncState()
    }

    window.addEventListener(SHARED_MODAL_UI_EVENT, syncState)
    window.addEventListener('storage', onStorage)

    return () => {
      window.removeEventListener(SHARED_MODAL_UI_EVENT, syncState)
      window.removeEventListener('storage', onStorage)
    }
  }, [])

  const setShowFilter = useCallback((next) => {
    const current = readSharedState()
    const value = typeof next === 'function' ? next(current.showFilter) : next
    const updated = { ...current, showFilter: Boolean(value) }
    writeSharedState(updated)
    setSharedState(updated)
  }, [])

  const setShowSearch = useCallback((next) => {
    const current = readSharedState()
    const value = typeof next === 'function' ? next(current.showSearch) : next
    const updated = { ...current, showSearch: Boolean(value) }
    writeSharedState(updated)
    setSharedState(updated)
  }, [])

  return {
    showFilter: sharedState.showFilter,
    setShowFilter,
    showSearch: sharedState.showSearch,
    setShowSearch
  }
}

export default useSharedModalUiState
